import store from '@/state/store'
// temporary commented
// const fields = [
//   {
//     key: 'driver',
//     label: 'global.object.driver',
//     header: 'driver',
//     filter: true,
//     width: 20,
//     headerRowspan: 2,
//   },
//   {
//     key: 'totalDriven',
//     label: 'report.fields.totalDistance',
//     header: 'total_driven',
//     filter: true,
//     width: 20,
//     headerRowspan: 2,
//   },
//   {
//     key: 'numberOfEvents',
//     label: 'driverScore.field.totalAlert',
//     filter: false,
//     width: 30,
//     children: [
//       {
//         key: 'harshAccels',
//         label: 'global.alert.suddenAcceleration',
//         header: 'column_harsh_accels',
//         childOfIndex: 0,
//         isTopHead: 1,
//         headerColspan: 1,
//       },
//       {
//         key: 'harshBrakes',
//         label: 'global.alert.suddenDeceleration',
//         header: 'column_harsh_brakes',
//         childOfIndex: 0,
//         isTopHead: 0,
//         headerColspan: 1,
//       },
//       {
//         key: 'sharpTurns',
//         label: 'global.alert.sharpTurn',
//         header: 'column_sharp_turns',
//         childOfIndex: 0,
//         isTopHead: 0,
//         headerColspan: 1,
//       },
//       {
//         key: 'overspeeds',
//         label: 'global.alert.overspeed',
//         header: 'column_overspeed',
//         childOfIndex: 0,
//         isTopHead: 0,
//         headerColspan: 1,
//       },
//     ],
//     headerColspan: 4,
//   },
//   {
//     key: 'alertScore',
//     label: 'driverScore.field.alertScore',
//     filter: false,
//     width: 30,
//     children: [
//       {
//         key: 'scoreAccel',
//         label: 'global.alert.suddenAcceleration',
//         header: 'cost_accel',
//         childOfIndex: 1,
//         isTopHead: 1,
//         headerColspan: 1,
//       },
//       {
//         key: 'scoreBrake',
//         label: 'global.alert.suddenDeceleration',
//         header: 'cost_brake',
//         childOfIndex: 1,
//         isTopHead: 0,
//         headerColspan: 1,
//       },
//       {
//         key: 'scoreSharpturn',
//         label: 'global.alert.sharpTurn',
//         header: 'cost_sharp_turn',
//         childOfIndex: 1,
//         isTopHead: 0,
//         headerColspan: 1,
//       },
//       {
//         key: 'scoreOverspeed',
//         label: 'global.alert.overspeed',
//         header: 'cost_overspeed',
//         childOfIndex: 1,
//         isTopHead: 0,
//         headerColspan: 1,
//       },
//     ],
//     headerColspan: 4,
//   },
//   {
//     key: 'score',
//     label: 'report.fields.totalScore',
//     header: 'score',
//     filter: false,
//     width: 20,
//     headerRowspan: 2,
//   },
//   {
//     key: 'finalGrade',
//     label: 'global.object.index',
//     header: 'final_grade',
//     filter: true,
//     width: 20,
//     headerRowspan: 2,
//   },
// ]
const fields = [
  {
    key: 'driver',
    label: 'global.object.driver',
    header: 'driver',
    filter: true,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'totalDriven',
    label: 'report.fields.totalDistance',
    header: 'total_driven',
    filter: false,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'overspeed',
    label: 'report.fields.exceedLimit',
    filter: false,
    disabled: true,
    width: 30,
    children: [
      {
        key: 'overspeeds',
        label: 'report.fields.numberOfEvents',
        header: 'column_overspeed',
        childOfIndex: 0,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'scoreOverspeed',
        label: 'report.fields.scoreDeduction',
        header: 'cost_overspeed',
        childOfIndex: 0,
        isTopHead: 0,
        headerColspan: 1,
      },
    ],
    headerColspan: 2,
  },
  {
    key: 'speeding',
    label: 'global.alert.suddenAcceleration',
    filter: false,
    disabled: true,
    width: 30,
    children: [
      {
        key: 'harshAccels',
        label: 'report.fields.numberOfEvents',
        header: 'column_harsh_accels',
        childOfIndex: 1,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'scoreAccel',
        label: 'report.fields.scoreDeduction',
        header: 'cost_accel',
        childOfIndex: 1,
        isTopHead: 0,
        headerColspan: 1,
      },
    ],
    headerColspan: 2,
  },
  {
    key: 'slowdown',
    label: 'global.alert.suddenDeceleration',
    filter: false,
    disabled: true,
    width: 30,
    children: [
      {
        key: 'harshBrakes',
        label: 'report.fields.numberOfEvents',
        header: 'column_harsh_brakes',
        childOfIndex: 2,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'scoreBrake',
        label: 'report.fields.scoreDeduction',
        header: 'cost_brake',
        childOfIndex: 2,
        isTopHead: 0,
        headerColspan: 1,
      },
    ],
    headerColspan: 2,
  },
  {
    key: 'sharpTurn',
    label: 'global.alert.sharpTurn',
    filter: false,
    disabled: true,
    width: 30,
    children: [
      {
        key: 'sharpTurns',
        label: 'report.fields.numberOfEvents',
        header: 'column_sharp_turns',
        childOfIndex: 3,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'scoreSharpturn',
        label: 'report.fields.scoreDeduction',
        header: 'cost_sharp_turn',
        childOfIndex: 3,
        isTopHead: 0,
        headerColspan: 1,
      },
    ],
    headerColspan: 2,
  },
  {
    key: 'score',
    label: 'report.fields.totalScore',
    header: 'score',
    filter: false,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'finalGrade',
    label: 'global.object.index',
    header: 'final_grade',
    filter: true,
    width: 20,
    headerRowspan: 2,
  },
]
if (!store.getters['identity/hasAccess'](['b4a-penilaian-pengemudi-v2:read'])) {
  fields.splice(1, 0, {
    key: 'baseScore',
    label: 'driverScore.field.initialScore',
    header: 'base_score',
    filter: false,
    width: 20,
    headerRowspan: 2,
  })
  fields.splice(3, 0, {
    key: 'totalBonus',
    label: 'driverScore.field.travelScore',
    header: 'score_driven',
    filter: false,
    width: 20,
    headerRowspan: 2,
  })
}
export default fields
